import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { PolymorphicComponentPropWithRef, PolymorphicRef } from '../../../../type-utils';
import { useVerticalSlideModalContext } from '../vertical-slide-modal';
import { verticalSlideModalContent } from '../vertical-slide-modal.styles';

type VerticalSlideModalContentProps<C extends React.ElementType> = PolymorphicComponentPropWithRef<C>;

type VerticalSlideModalContentComponent = <C extends React.ElementType = 'div'>(
  props: VerticalSlideModalContentProps<C>
) => React.ReactNode;

export const VerticalSlideModalContent: VerticalSlideModalContentComponent = forwardRef(
  <C extends React.ElementType = 'div'>(
    { children, as, className, ...rest }: VerticalSlideModalContentProps<C>,
    ref: PolymorphicRef<C>
  ) => {
    const { descriptionId } = useVerticalSlideModalContext();
    const Component = as || 'div';

    return (
      <Component ref={ref} className={cx(verticalSlideModalContent, className)} {...rest} id={descriptionId}>
        {children}
      </Component>
    );
  }
);
